// convert JavaScript date to yyyy-mm-dd format
export const convertDateToCustomFormat = (date: Date) => {
    const offset = date.getTimezoneOffset()
    date = new Date(date.getTime() - (offset * 60 * 1000))
    return date.toISOString().split('T')[0]
}